import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class AspInstantOrderQuoteService {

  constructor(private http: HttpClient) { }

  uploadCarImage(imageFile: File) {

    const formData = new FormData();
    formData.append('file', imageFile);
    formData.append('showDetails', 'true');

    const headers = new HttpHeaders({
      'x-api-key':  `${GlobalVariable.AUTOVERSE_ELASTIC_KEY}`,
      'accept': 'application/json'
    });

    return this.http.post(`${GlobalVariable.BASE_API_URL_ELASTIC}`+'/parse-car-register-plate', formData, { headers });
  }
  //  getSuggest(relevancyCount, variant,partNames, garageKey): Observable<any>{
  //   // console.log("partNames", partNames);
  //   const encoded = encodeURIComponent(partNames);
  //     const headers = new HttpHeaders({
  //       'x-api-key': `${GlobalVariable.AUTOVERSE_ELASTIC_KEY}`,
  //     });
  
  //     // console.log('-----Get suggest List-----------',headers);    
  //     return this.http.get(`${GlobalVariable.BASE_API_URL_ELASTIC}` + '/part-name-suggestions-warehouse?relevancyCount='+relevancyCount+'&vendor='+true+'&partInfoResult='+1+'&variant='+variant+'&partNames='+encoded+'&garageKey='+garageKey+'&showResult='+1, { headers: headers });
  //   }
  getSuggest(partNames): Observable<any> {
    const encoded = encodeURIComponent(partNames);
    const headers = new HttpHeaders({
      'x-api-key': `${GlobalVariable.AUTOVERSE_ELASTIC_KEY}`,
    });

    return this.http.get(
      `${GlobalVariable.BASE_API_URL_ELASTIC}` + '/correct-part-name-suggestions?partNames=' + encoded,
      { headers: headers }
    );
  }
    
    createQuotation(requestBody: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}`+'/spare/request/create/quotation', requestBody, { headers });
  }
  getSpareQuotation(spareQuotationId, spareGarageId) {
       const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    return this.http.post(`${GlobalVariable.BASE_API_URL}`+ `/b2bgetsparequotation?spareQuotationId=${spareQuotationId}&spareGarageId=${spareGarageId}&type=pitstopspare`, { headers }); // no body needed
  }
  getPartKeyData(partNumber){
  const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
    partNumbers: partNumber // <-- This matches your desired format
  };

    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}`+'/spare/partKey', body, { headers });

  }
  getSpareRequest(type: string, spareGarageId: string, requestId: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${GlobalVariable.BASE_API_URL}/b2bgetsparerequest?type=${type}&spareGarageId=${spareGarageId}&requestId=${requestId}`;

    return this.http.post(url, {}, { headers });
  }
  uploadSpareRequestImage(requestId: number, garageKey: string, imageFile: File) {
    const formData = new FormData();
    formData.append('file', imageFile);

    const headers = new HttpHeaders({
      'x-api-key': `${GlobalVariable.AUTOVERSE_API_KEY}`,
      'accept': 'application/json'
    });

    const url = `${GlobalVariable.BASE_API_URL_SPARES}/spare/request/upload/image?requestId=${requestId}&garageKey=${garageKey}`;
    // console.log("PUT URL:", url);

    return this.http.put(url, formData, { headers });
  }

}